module.exports = __webpack_public_path__ + "img/carousel-arrow-left.58c42681.svg";